export const ROLE = Object.freeze({
    LENDER: "lending",
    BORROWER: "borrowing",
});

export const VIEWS = Object.freeze({
    TRANSACTIONS: "negotiations",
    INVENTORY: "inventory",
    AVAILABILITY: "availability",
    CONFIRMATIONS: "confirmations",
    RECALLS: "recalls",
    CLIENT_POOL: "client-pool",
    POST_TRADE: "post-trade",
    DASHBOARD: "dashboard",
    CPTIES: "cpties",
    FEATURE_FLAGS: "feature-flags",
    USERS: "users",
    PLATFORM: "platform",
    SECURITY: "security",
    AUDIT: "audit",
});
